






































































































































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { VueEditor } from "vue2-editor";
import { randomId } from "@/utils";

@Component({
  components: {
    BPopover,
    VueEditor,
  },
})
export default class InputPopover extends Vue {
   @Model("changed") readonly model!: string;
 //  @Model("changed") readonly model!:  {text:"",text2:""};
  @Prop(Number) readonly itemId!: number;
  @Prop(Number) readonly index!: number;
  @Prop(String) readonly toggleType!: string;
  @Prop(String) readonly toggleLabel!: string;
  @Prop() readonly toggleClass!: string;
  @Prop(String) readonly buttonIcon!: string;
  @Prop(String) readonly saveButtonIcon!: string;
  @Prop(String) readonly saveButtonLabel!: string;
  @Prop(String) readonly inputType!: string;
  @Prop(String) readonly inputText!: string;
  @Prop(String) readonly inputText2!: string;
  @Prop(String) readonly title!: string;
  @Prop(String) readonly placeholder1!: string;
  @Prop(String) readonly placeholder2!: string;
  id = `input-popover-id-${randomId(6)}`;
  target = `input-popover-target-${randomId(6)}`;
  text = "";
  text2 = "";
  show = false;
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  shown() {
    this.text = this.inputText;
    this.text2 = this.inputText2;
    this.$emit("shown");
  }
  save() {
    
    this.$emit("changed", this.text,this.text2,this.itemId,this.index);
    if (!this.inputText) {
      this.text = "";
    }

    if (!this.inputText2) {
      this.text2 = "";
    }
    this.close();
  }
  clear() {
    this.text = "";
    this.save();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.shown();
  }
}
